import { render } from "./personal_details.html?vue&type=template&id=ece7d5a0&external"
import script from "./personal_details.js?vue&type=script&lang=js&external"
export * from "./personal_details.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__